import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
	appid: '',
}

export default {
	state,
	getters,
	actions,
	mutations
};